import { render, staticRenderFns } from "./blockLabel.vue?vue&type=template&id=371fa9b2&scoped=true&"
import script from "./blockLabel.vue?vue&type=script&lang=js&"
export * from "./blockLabel.vue?vue&type=script&lang=js&"
import style0 from "./blockLabel.vue?vue&type=style&index=0&id=371fa9b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "371fa9b2",
  null
  
)

export default component.exports